/** Shared MaterialReactTable options matching Assign Roles tab styling */
export const getRoleAssignmentTableBaseOptions = (overrides = {}) => ({
  enableGlobalFilter: false,
  enableGlobalFilterModes: false,
  positionGlobalFilter: 'none',
  enableColumnFilterModes: false,
  enableColumnOrdering: false,
  enableGrouping: false,
  enableRowSelection: false,
  enableSelectAll: false,
  enableColumnPinning: false,
  enableFacetedValues: false,
  enableSorting: false,
  enableDensityToggle: false,
  paginationDisplayMode: 'pages',
  positionToolbarAlertBanner: 'bottom',
  enableBottomToolbar: true,
  enableStickyHeader: true,
  enableStickyFooter: true,
  enablePagination: true,
  muiCircularProgressProps: {
    color: 'inherit',
    size: 40,
    sx: { color: '#999999' },
  },
  muiSearchTextFieldProps: {
    size: 'small',
    variant: 'outlined',
  },
  muiPaginationProps: {
    color: 'secondary',
    rowsPerPageOptions: [10, 20, 30, 40],
    shape: 'rounded',
    variant: 'outlined',
    sx: {
      '& .MuiPaginationItem-root.Mui-selected': {
        backgroundColor: '#BD1D23',
        color: 'white',
      },
    },
  },
  muiTableBodyRowProps: {
    sx: {
      height: 52,
      minHeight: 52,
      maxHeight: 52,
    },
  },
  muiTableBodyCellProps: {
    sx: {
      color: '#667085',
      backgroundColor: '#fff',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '125%',
      padding: '0 12px',
      '&:first-of-type': {
        paddingLeft: '12px !important',
      },
    },
  },
  muiTableHeadCellProps: {
    sx: {
      color: '#344054',
      backgroundColor: '#E8E9E9',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: '125%',
      height: '56px',
      padding: '0 12px',
      alignItems: 'center',
      '&:first-of-type': {
        paddingLeft: '18px !important',
      },
    },
  },
  muiTablePaperProps: {
    sx: {
      boxShadow: 'none',
    },
  },
  muiTableHeadRowProps: {
    sx: {
      height: 56,
      '& .MuiTableCell-root': {
        padding: '6px 12px',
        verticalAlign: 'middle',
      },
    },
  },
  initialState: {
    pagination: {
      pageSize: 10,
    },
    ...overrides.initialState,
  },
  ...overrides,
});
